/*
This file was created by the script build.py 
*/

import {buttonOnClick, checkAllButtons, callAllCategories} from "./globalFilterUI"
import {allCheckboxesState} from "./checkboxState"

// show or hide buttons
$(document).ready(function(){
    $("#iconFinalStatesSignature").click(function(){
        var buttons = document.getElementById("buttonWrapperFinalStatesSignature")
        const iconId = "#"+$(this).attr('id');
        if(buttons.classList.contains("show")){
            $(buttons).hide()
            buttons.classList.remove("show")
            $(iconId).toggleClass("bi bi-caret-up-fill", false)
            $(iconId).toggleClass("bi bi-caret-down-fill", true)
        }
        else{
            $(buttons).show()
            buttons.classList.add("show")
            $(iconId).toggleClass("bi bi-caret-down-fill", false)
            $(iconId).toggleClass("bi bi-caret-up-fill", true)
        }
    })
})

//checkbox Final States Signature
document.getElementById("categoryFinalStatesSignature").onclick=function(){
    const checkboxId = $(this).attr('id')
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    if(allCheckboxesState[checkboxId].checked){
        checkbox.checked = true
    }
    else if(allCheckboxesState[checkboxId].indeterminate){
        checkbox.indeterminate = true
    }
    else{
        checkbox.checked = false
    }
    
    const iconId = "#iconFinalStatesSignature";
    var buttons = document.getElementById("buttonWrapperFinalStatesSignature")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    allCheckboxesState[checkboxId].checked = checkbox.checked

}

//Name Final States Signature
document.getElementById("finalStatesSignatureLabel").onclick=function(){
    const iconId = "#iconFinalStatesSignature";
    var buttons = document.getElementById("buttonWrapperFinalStatesSignature")
    if(buttons.classList.contains("show")){
        $(buttons).hide()
        buttons.classList.remove("show")
        $(iconId).toggleClass("bi bi-caret-up-fill", false)
        $(iconId).toggleClass("bi bi-caret-down-fill", true)
    }
    else{
        $(buttons).show()
        buttons.classList.add("show")
        $(iconId).toggleClass("bi bi-caret-down-fill", false)
        $(iconId).toggleClass("bi bi-caret-up-fill", true)
    }
    
}

//Button: "select all buttons"
document.getElementById("buttonFinalStatesSignatureSelectAll").onclick=function(){
    const checkboxId = "categoryFinalStatesSignature"
    var checkbox = document.getElementById(checkboxId)
    checkbox.indeterminate = false
    checkbox.checked = true
    allCheckboxesState[checkboxId].checked = checkbox.checked
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

//Button: "select none buttons"
document.getElementById("buttonFinalStatesSignatureSelectNone").onclick=function(){
    const checkboxId = "categoryFinalStatesSignature"
    var checkbox = document.getElementById(checkboxId)
    checkbox.checked = false
    checkbox.indeterminate = false
    allCheckboxesState[checkboxId].checked = checkbox.checked
    allCheckboxesState[checkboxId].indeterminate = checkbox.indeterminate
    checkAllButtons({
        "checkboxId" : checkboxId
    })

    callAllCategories()
}

// any-Button Final States Signature
document.getElementById("buttonFinalStatesSignatureAny").onclick = function(){
    var buttonAny = document.getElementById("buttonFinalStatesSignatureAny")
    var buttonAll = document.getElementById("buttonFinalStatesSignatureAll")
    buttonAny.classList.add("chosen","text-light","no-click");
    buttonAll.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}

// all-Button Final States Signature
document.getElementById("buttonFinalStatesSignatureAll").onclick = function(){
    var buttonAny = document.getElementById("buttonFinalStatesSignatureAny")
    var buttonAll = document.getElementById("buttonFinalStatesSignatureAll")
    buttonAll.classList.add("chosen","text-light","no-click");
    buttonAny.classList.remove("chosen","text-light","no-click")
    callAllCategories()
}


//Button BHadrons in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureBHadrons").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button CHadrons in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureCHadrons").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Detectorperformance in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureDetectorperformance").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button diBoson in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignaturediBoson").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button diHiggs in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignaturediHiggs").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Electron in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureElectron").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Higgsbosons in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureHiggsbosons").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button LongLivedsignature in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureLongLivedsignature").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button MissingenergyInvisible in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureMissingenergyInvisible").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Muon in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureMuon").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Photon in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignaturePhoton").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Taggedproton in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureTaggedproton").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Tau in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureTau").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Top in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureTop").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Tracks in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureTracks").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button triAndmultibosons in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignaturetriAndmultibosons").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button ttbarAnythingbutHiggs in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignaturettbarAnythingbutHiggs").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button ttbarHiggsboson in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignaturettbarHiggsboson").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Wboson in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureWboson").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

//Button Zboson in Final States Signature change color on click Event
document.getElementById("buttonFinalStatesSignatureZboson").onclick = function(){
    buttonOnClick({
        "buttonId" : $(this).attr('id') 
    })
}

